export interface IUser {
    userId: string;
    userName: string;
    account: string;
    accessKey: string;
    accessToken: string;
    organizationId?: any;
    /** checkLogin 返回：1 为律所，其余为通用企业 */
    companyType?: number | string | null;
}

export function getCurrentUser(): IUser | undefined | any {
    const user = localStorage.getItem("user");
    if (
        window.location.pathname !== "/login" &&
        (!user || user == "undefined" || user == "null")
    ) {
        window.location.replace('/login');
    } else {

        return user && user != "undefined" && (JSON.parse(user) as IUser) || undefined;
    }
}

export function setCurrentUser(user: IUser) {
    localStorage.setItem("user", JSON.stringify(user));
}

export function removeCurrentUser() {
    localStorage.removeItem("user");
    localStorage.removeItem('token')
}
